/**
 * 智慧农业云平台 - 路由配置
 * 所属公司：河南农博联信息技术有限公司
 * 开发人员：王健
 * 提交时间：2025年
 */
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/screen/Dashboard.vue'),
    meta: { title: '首页大屏' }
  },
  {
    path: '/monitor',
    name: 'Monitor',
    component: () => import('@/views/screen/Monitor.vue'),
    meta: { title: '农情监测' }
  },
  {
    path: '/irrigation',
    name: 'Irrigation',
    component: () => import('@/views/screen/Irrigation.vue'),
    meta: { title: '智能灌溉' }
  },
  {
    path: '/analysis',
    name: 'Analysis',
    component: () => import('@/views/screen/Analysis.vue'),
    meta: { title: '分析与决策' }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: () => import('@/views/admin/Layout.vue'),
    redirect: '/admin/home',
    children: [
      {
        path: 'home',
        name: 'AdminHome',
        component: () => import('@/views/admin/Home.vue'),
        meta: { title: '后台首页' }
      },
      // 主体管理
      { path: 'subject/plot', name: 'Plot', component: () => import('@/views/admin/subject/Plot.vue'), meta: { title: '地块管理' } },
      { path: 'subject/planting', name: 'Planting', component: () => import('@/views/admin/subject/Planting.vue'), meta: { title: '种植管理' } },
      { path: 'subject/fence', name: 'Fence', component: () => import('@/views/admin/subject/Fence.vue'), meta: { title: '电子围栏' } },
      // 农资管理
      { path: 'material/stock', name: 'MaterialStock', component: () => import('@/views/admin/material/Stock.vue'), meta: { title: '农资库存' } },
      { path: 'material/in', name: 'MaterialIn', component: () => import('@/views/admin/material/InStock.vue'), meta: { title: '农资入库' } },
      { path: 'material/out', name: 'MaterialOut', component: () => import('@/views/admin/material/OutStock.vue'), meta: { title: '农资出库' } },
      { path: 'material/loss', name: 'MaterialLoss', component: () => import('@/views/admin/material/Loss.vue'), meta: { title: '农资库损' } },
      { path: 'material/type', name: 'MaterialType', component: () => import('@/views/admin/material/Type.vue'), meta: { title: '农资类型' } },
      // 农事管理
      { path: 'farm/work', name: 'FarmWork', component: () => import('@/views/admin/farm/FarmWork.vue'), meta: { title: '农事登记' } },
      { path: 'farm/record', name: 'FarmRecord', component: () => import('@/views/admin/farm/FarmWork.vue'), meta: { title: '农事记录' } },
      { path: 'farm/feedback', name: 'Feedback', component: () => import('@/views/admin/farm/Feedback.vue'), meta: { title: '意见反馈' } },
      // 农情管理
      { path: 'farm/soil', name: 'Soil', component: () => import('@/views/admin/farm/Soil.vue'), meta: { title: '土壤墒情' } },
      { path: 'farm/seedling', name: 'Seedling', component: () => import('@/views/admin/farm/Seedling.vue'), meta: { title: '苗情监测' } },
      { path: 'farm/pest', name: 'Pest', component: () => import('@/views/admin/farm/Pest.vue'), meta: { title: '虫情监测' } },
      { path: 'farm/weather', name: 'Weather', component: () => import('@/views/admin/farm/Weather.vue'), meta: { title: '气候监测' } },
      { path: 'farm/spore', name: 'Spore', component: () => import('@/views/admin/farm/Spore.vue'), meta: { title: '孢子监测' } },
      // 灌溉管控
      { path: 'irrigation/control', name: 'IrrControl', component: () => import('@/views/admin/irrigation/IrrigationControl.vue'), meta: { title: '灌溉施肥' } },
      { path: 'irrigation/task-setting', name: 'TaskSetting', component: () => import('@/views/admin/irrigation/TaskSetting.vue'), meta: { title: '任务设置' } },
      { path: 'irrigation/history', name: 'HistoryTask', component: () => import('@/views/admin/irrigation/HistoryTask.vue'), meta: { title: '历史任务' } },
      { path: 'irrigation/fertilizer-config', name: 'FertilizerConfig', component: () => import('@/views/admin/irrigation/FertilizerConfig.vue'), meta: { title: '施肥机配置' } },
      { path: 'irrigation/fertilizer-assignment', name: 'FertilizerAssignment', component: () => import('@/views/admin/irrigation/FertilizerAssignment.vue'), meta: { title: '施肥机分配' } },
      { path: 'irrigation/valve-assignment', name: 'ValveAssignment', component: () => import('@/views/admin/irrigation/ValveAssignment.vue'), meta: { title: '智能阀控分配' } },
      { path: 'irrigation/record', name: 'IrrigationRecord', component: () => import('@/views/admin/irrigation/IrrigationRecord.vue'), meta: { title: '灌溉记录' } },
      // 设备管理
      { path: 'device/register', name: 'DeviceRegister', component: () => import('@/views/admin/device/Register.vue'), meta: { title: '设备登记' } },
      { path: 'device/maintain', name: 'DeviceMaintain', component: () => import('@/views/admin/device/Maintain.vue'), meta: { title: '设备维护' } },
      { path: 'device/type', name: 'DeviceType', component: () => import('@/views/admin/device/Type.vue'), meta: { title: '设备类型' } },
      // 预警管理
      { path: 'device/alarm', name: 'DeviceAlarm', component: () => import('@/views/admin/device/Alarm.vue'), meta: { title: '设备报警' } },
      { path: 'device/warning', name: 'DeviceWarning', component: () => import('@/views/admin/device/Alarm.vue'), meta: { title: '预警查询' } },
      // 种植管理
      { path: 'plant/crop', name: 'Crop', component: () => import('@/views/admin/plant/Crop.vue'), meta: { title: '作物管理' } },
      { path: 'plant/advice', name: 'Advice', component: () => import('@/views/admin/plant/Advice.vue'), meta: { title: '种植建议' } },
      // 系统管理
      { path: 'system/user', name: 'User', component: () => import('@/views/admin/system/User.vue'), meta: { title: '用户管理' } },
      { path: 'system/role', name: 'Role', component: () => import('@/views/admin/system/Role.vue'), meta: { title: '角色管理' } },
      { path: 'system/menu', name: 'Menu', component: () => import('@/views/admin/system/Menu.vue'), meta: { title: '菜单管理' } },
      { path: 'system/county', name: 'County', component: () => import('@/views/admin/system/County.vue'), meta: { title: '县级区划管理' } },
      { path: 'system/town', name: 'Town', component: () => import('@/views/admin/system/Town.vue'), meta: { title: '乡镇区划管理' } },
      { path: 'system/village', name: 'Village', component: () => import('@/views/admin/system/Village.vue'), meta: { title: '村级区划管理' } },
      { path: '*', redirect: '/admin/home' }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 修复重复导航到当前路由的报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(() => {})
}

// 路由守卫 - 验证登录状态
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    const token = localStorage.getItem('token')
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
